import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CAR_TYPE_BY_VENDOR, GET_CAR_TYPE_BY_VENDOR_SUCCESS, GET_CAR_TYPE_BY_VENDOR_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCarTypeByVendor({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/configuration/vendors/car-types`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CAR_TYPE_BY_VENDOR_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CAR_TYPE_BY_VENDOR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CAR_TYPE_BY_VENDOR_ERROR, payload: error });
  }
}

export function* watchGetCarTypeByVendor() {
  yield takeEvery(GET_CAR_TYPE_BY_VENDOR, getCarTypeByVendor);
}

function* getCarTypeByVendorSaga() {
  yield all([fork(watchGetCarTypeByVendor)]);
}

export default getCarTypeByVendorSaga;
